import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { ElementType } from "react";

import NodeWithTranslation from "@/view/TiptapArticleBody/components/NodeWithTranslation";
import { getNodeType } from "@/view/TiptapArticleBody/components/TextSelectionMenu/AnnotationsTextSelectionMenu/utils";
import { ComponentProps } from "@/view/TiptapArticleBody/TiptapArticleBody.interface";

export interface ListBlockOptions {
  disableTranslation?: boolean;
}

export const ListComponent = ({
  editor,
  node,
  extension,
}: ComponentProps<ListBlockOptions>) => {
  const listType = getNodeType(node) as ElementType;
  const { disableTranslation = false } = extension?.options;

  return (
    <NodeWithTranslation
      state={editor.state}
      node={node}
      props={{ as: listType }}
      disableTranslation={disableTranslation}
    />
  );
};

const BaseList = Node.create<ListBlockOptions>({
  content: "text*",
  group: "inline",
  inline: true,
  addAttributes() {
    return {
      "data-identifier": {
        default: null,
      },
    };
  },
  addOptions() {
    return {
      disableTranslation: false,
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(ListComponent);
  },
});

export const OrderedList = BaseList.extend({
  name: "orderedList_block_0",
  renderHTML() {
    return ["ol", 0];
  },
});

export const UnorderedList = BaseList.extend({
  name: "list_block_0",
  renderHTML() {
    return ["ul", 0];
  },
});
